import { Service } from '@angular/core';

@Service()
export class SignInService {
  // Cross-page session state: one page assigns, another reads, so every field is genuinely unset
  // until whichever page sets it runs.
  passwordResetRequestId?: string;
  passwordResetEmail?: string;
  otpResetRequestId?: string;
  signInEmail?: string;
  signInPassword?: string;
  registrationReturnUrl?: string;
  signInReturnUrl?: string;
}
